import { LucideIcon } from "lucide-react";
import styles from "./PrimaryButton.module.css"
/**
* Props for the PrimaryButton component.
*/ 
interface PrimaryButtonTypes {
    text: string, // Button label
    disabled?: boolean, // Disable the button
    onClick: (v: any) => void, // Click event handler
    className? :string, // Optional additional class
    Icon?: LucideIcon // Optional Icon
}
/**
* A button with label
*
* @param props PrimaryButton props
* @param {string} props.text - Button label
* @param {boolean} props.disabled - Disable the button
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @returns TSX.Element
*/
const PrimaryButton = ({ text, disabled = false, onClick, className, Icon } : PrimaryButtonTypes) => {
    return(
        <>
            <button onClick={onClick} className={`${styles.PrimaryButton} ${disabled ? styles.Disabled : ''} ${className ?? ''}`}disabled={disabled? true : false}>
                <span>{text}</span>
                {Icon && <Icon/> }
            </button>
        </>
    )
};
export default PrimaryButton;